/**
 * 题目的默认值
 */

export default {
  stepId: '',
  title: '',
  titleAlias: '',
  type: '',
  images: [],
  desc: '',
  descPrefix: '',
  default_jump: '',
  conditional_jump: {},
  referStepId: '',
  referIds: [],
  delay: '0',
  needPhoto: true,
  forceCamera: true,
  clarity: '0',
  videoDuration: '0',
  recordDuration: '0',
  evidenceQuality: '2',
  evidenceType: 'photo',
  imageRecognitionType: [],
  reportedTablesAssociationStepId: '',
  takePhotoAuxiliaryLine: 0,
  forcePanorama: false,
  takePhotoScene: 0, // 2022-07-13 新增拍照场景（陈列分组拍摄），是 forcePanorama 字段的替代
  allowReusePhoto: false,
  allowCrossSubjectRecord: false,
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  options: [],
  moptions: [],
  pictureMultipleOptions: [],
  mtext: [],
  guideText: '',
  guideVideo: [],
  guideAudio: [],
  dataLabel: '',
  forceGuideVideo: false,
  forceGuideAudio: false,
  auditText: '',
  intelligentCall: false,
  keyin_ids: [],
  ondutyCheck: false,
  throughRecordKeyQuestion: false,
  allow_screen_capture: 2,
  allow_media_download: 2,
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/recovery-fields/question.js